import { render } from "./InstituteView.vue?vue&type=template&id=a6c19274&scoped=true"
import script from "./InstituteView.vue?vue&type=script&lang=js"
export * from "./InstituteView.vue?vue&type=script&lang=js"

import "./InstituteView.vue?vue&type=style&index=0&id=a6c19274&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c19274"]])

export default __exports__